/* @generated */
import classNames from "classnames";
import * as React from "react";
import { IconContext } from "./icon_context";
export function getSizeInPx(size, height, width) {
  if (height !== void 0 || width !== void 0) {
    if (typeof height === "number") {
      return height;
    }
    if (typeof width === "number") {
      return width;
    }
    if (/px$/.test(height || width || "")) {
      const sizeNumber = (height || width || "0").match(/\d+/);
      const lastItem = sizeNumber ? sizeNumber.pop() : void 0;
      if (lastItem) {
        const integerSizeNumber = parseInt(lastItem, 10);
        if (!isNaN(integerSizeNumber)) {
          return parseInt(lastItem, 10);
        }
      }
    } else if (!isNaN(height || width)) {
      return parseInt(height || width || "", 10);
    }
  }
  switch (size) {
    case "small":
      return 16;
    case "large":
      return 32;
  }
  return 24;
}
function getNegatedMargin(size) {
  return Math.floor(size / -4) + 2;
}
export const UIIcon = ({
  className,
  // `src` is aliased as `IconComponent` for usage in JSX
  src: IconComponent,
  size: sizeProp = "medium",
  isOpticallyAligned: isOpticallyAlignedProp = false,
  height: heightProp,
  width: widthProp,
  ...rest
}) => {
  const { UIIconOverrides } = React.useContext(IconContext);
  const _size = UIIconOverrides && UIIconOverrides.size ? UIIconOverrides.size : sizeProp;
  const size = _size === "standard" ? "medium" : _size === 12 ? "small" : _size === 20 ? "medium" : _size;
  const opticalAlignment = UIIconOverrides && typeof UIIconOverrides.isOpticallyAligned !== "undefined" ? UIIconOverrides.isOpticallyAligned : isOpticallyAlignedProp;
  const cls = classNames(
    "dig-UIIcon",
    {
      "dig-UIIcon--small": size === "small",
      "dig-UIIcon--standard": size === "medium",
      "dig-UIIcon--is-optically-aligned": opticalAlignment
    },
    className
  );
  const isPresentation = !rest["aria-label"] && !rest["aria-labelledby"];
  const sizeUnit = getSizeInPx(size, heightProp, widthProp);
  const negatedMargin = {
    marginLeft: getNegatedMargin(sizeUnit),
    marginRight: getNegatedMargin(sizeUnit)
  };
  if (!opticalAlignment) {
    return /* @__PURE__ */ React.createElement(
      IconComponent,
      {
        className: cls,
        width: sizeUnit,
        height: sizeUnit,
        role: isPresentation ? "presentation" : void 0,
        focusable: "false",
        ...rest
      }
    );
  }
  return (
    // `cls` is moved to the wrapping `span` here because we want this to operate as if the `span`
    // was the `IconComponent` itself.
    // inline-flex and lineHeight:0 are used to remove the whitespace below the icon that would appear
    // due to `inline-flex` inheriting line-height from the parent.
    /* @__PURE__ */ React.createElement("span", { className: cls, style: { display: "inline-flex", lineHeight: 0 } }, /* @__PURE__ */ React.createElement(
      IconComponent,
      {
        width: sizeUnit,
        height: sizeUnit,
        role: isPresentation ? "presentation" : void 0,
        focusable: "false",
        style: negatedMargin,
        ...rest
      }
    ))
  );
};
UIIcon.displayName = "UIIcon";
